import { isSupported } from 'firebase/messaging'

import store from '@/store/store'

import { firebaseAppConfig, firebaseVapIdKey } from '@/libraries/firebase/firebaseConfig'
import createFirebaseManager from '@/libraries/firebase/firebaseManager'
import country from '@/utilities/country'

export default {
  install: async app => {
    if (country.isNot('tr')) {
      return
    }

    if (!import.meta.env.VITE_FIREBASE_API_KEY) {
      return
    }

    const isSupportedBrowser = await isSupported()
    if ( isSupportedBrowser === false) {
      return
    }

    const firebaseManager = createFirebaseManager({
      appConfig: firebaseAppConfig,
      vapidKey: firebaseVapIdKey
    })

    firebaseManager.onMessage(payload => {
      const { id, message, url, type } = payload.data

      const notification = {
        id: id,
        type: type,
        message: message,
        url: url
      }

      store.dispatch('retailerAuth/addNotification', notification).then(() => {
        store.dispatch('retailerAuth/setShowNotificationContainer', true)
      })
    })

    app.provide('firebaseManager', firebaseManager)
  }
}
